var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { FormField } from '../../form';
import { RadioGroup as RadioGroupBase } from '../../radio';
import { styled } from '../../styled';
import clsx from '../../utils/clsx';
import { getSelectableCardGroupUtilityClass, selectableCardGroupComponentName, selectableCardGroupClasses, } from './selectable-card-group-classes';
import { useMergedClasses } from '../../styles/classes';
var Root = styled(FormField, { name: selectableCardGroupComponentName, slot: 'Root' })({});
var RadioGroup = styled(RadioGroupBase, { name: selectableCardGroupComponentName, slot: 'RadioGroup' })(function (_a) {
    var theme = _a.theme, ownerState = _a.ownerState;
    return ({
        display: 'grid',
        gridTemplateColumns: ownerState.orientation === 'vertical' ? '1fr' : 'repeat(auto-fit, minmax(175px, 1fr))',
        gridGap: theme.spacing(1),
    });
});
export var SelectableCardGroup = React.forwardRef(function (props, ref) {
    var onChange = props.onChange, value = props.value, name = props.name, children = props.children, className = props.className, _a = props.component, component = _a === void 0 ? 'fieldset' : _a, _b = props.orientation, orientation = _b === void 0 ? 'horizontal' : _b, RadioGroupProps = props.RadioGroupProps, InputLabelProps = props.InputLabelProps, 
    // remove to prevent passing through to the root
    propClasses = props.classes, rootProps = __rest(props, ["onChange", "value", "name", "children", "className", "component", "orientation", "RadioGroupProps", "InputLabelProps", "classes"]);
    var classes = useMergedClasses(selectableCardGroupClasses, getSelectableCardGroupUtilityClass, propClasses);
    return (React.createElement(Root, __assign({ fullWidth: true, className: clsx(classes.root, className), ref: ref, component: component }, rootProps, { InputLabelProps: __assign({ component: 'legend' }, InputLabelProps) }),
        React.createElement(RadioGroup, __assign({ className: classes.radioGroup, ownerState: { orientation: orientation }, onChange: onChange, value: value, name: name }, RadioGroupProps), children)));
});
